// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import FileItem from "./FileItem-APP_CLIENT.styled";

export default FileItem;
